import React, { useState } from 'react';
import Slider from '../../../../../components/utils/Slider';
import Img from '../../../../../components/Img';

const EventSwipeSectionTypeImg = (props) => {
  const { imgList, isInfinity } = props;
  const [current, setCurrent] = useState(1);

  if (!imgList.length) return null;
  return (
    <div className="event-section-images">
      <span className="event-section-image-page-number">
        <span>
          {current}/{imgList.length}
        </span>
      </span>

      <Slider
        className="event-section-images-slider"
        emptyText="이미지가 없습니다."
        list={imgList}
        infinite={isInfinity}
        arrows={false}
        afterChange={(index) => setCurrent(index + 1)}
        item={(url) => (
          <div className="event-section-image">
            <Img src={url} clickAble={false} />
          </div>
        )}
      />
    </div>
  );
};

export default EventSwipeSectionTypeImg;
